/* eslint-disable react/prop-types */
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Filler,
  Tooltip,
  Legend,
} from "chart.js";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { useTheme } from "@mui/material/styles";

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Filler, Tooltip, Legend);

export default function GivingTrendChart({ data }) {
  const theme = useTheme();

  const hasData = data && data.length > 0 && data.some((d) => d.total > 0);

  if (!hasData) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography variant="body2" color="text.secondary">
          No giving recorded in the last 30 days.
        </Typography>
      </Box>
    );
  }

  const chartData = {
    labels: data.map((d) => d.day),
    datasets: [
      {
        label: "Total Giving",
        data: data.map((d) => d.total),
        borderColor: theme.palette.teal[600],
        backgroundColor: `${theme.palette.teal[400]}33`,
        pointRadius: 0,
        pointHoverRadius: 4,
        borderWidth: 2,
        tension: 0.35,
        fill: true,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: { mode: "index", intersect: false },
    plugins: {
      legend: { display: false },
      tooltip: {
        callbacks: {
          title: (items) => data[items[0].dataIndex].date,
          label: (item) => `Total: GHS ${Number(item.raw).toFixed(2)}`,
        },
      },
    },
    scales: {
      x: {
        grid: { display: false },
        ticks: { maxTicksLimit: 8, autoSkip: true },
      },
      y: { beginAtZero: true, grid: { color: theme.palette.ink[100] } },
    },
  };

  return (
    <Box sx={{ height: { xs: 220, md: 260 } }}>
      <Line data={chartData} options={options} />
    </Box>
  );
}
